import React from "react";

function Projects() {
  return (
    <div id="projects">
      <h1>Projects</h1>
      <div className="projects-container">
        {/* Mini Rover */}
        <div className="project-card">
          <a
            href="https://github.com/nevinadacakmak/pi-zero-rover"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            <div className="project-content">
              <h3>Mini Rover</h3>
              <p>
                Built a mini rover from scratch, using Raspberry Pi 2 Zero WH.
                GPIO drivers, 3D design for chassis, PWM signal, and more, all
                done by me.
              </p>
            </div>
          </a>
        </div>
        {/* Pi System Monitor */}
        <div className="project-card">
          <a
            href="https://github.com/nevinadacakmak/pi-sys-monitor"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            <div className="project-content">
              <h3>Pi System Monitor</h3>
              <p>
                Daemon and HTTP JSON API serving live CPU, memory, temperature
                metrics; built an HTTP server using raw BSD sockets.
              </p>
            </div>
          </a>
        </div>

        {/* C Shell*/}
        <div className="project-card">
          <a
            href="https://github.com/nevinadacakmak/shell-c"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            <div className="project-content">
              <h3>Unix Shell in C</h3>
              <p>
                Custom shell implementing parsing, pipes, redirection,
                background jobs, and signal handling.
              </p>
            </div>
          </a>
        </div>

        {/* System Monitoring Tools */}
        <div className="project-card">
          <a
            href="https://github.com/nevinadacakmak/c-linux"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            <div className="project-content">
              <h3>System Monitoring Tools</h3>
              <p>
                C CLI tools parsing /proc to surface CPU, memory, and process
                metrics with signal-aware process handling.
              </p>
            </div>
          </a>
        </div>

        {/* Assembly Game */}
        <div className="project-card">
          <a
            href="https://github.com/nevinadacakmak/b58-assemblygame"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            <div className="project-content">
              <h3>Assembly Game</h3>
              <p>
                MIPS Assembly 2D game with scoring, timed challenges, and
                bitmap-based rendering.
              </p>
            </div>
          </a>
        </div>

        <div className="project-card">
          <a
            href="https://github.com/nevinadacakmak/swipe-shield"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            <div className="project-content">
              <h3>SwipeShield</h3>
              <p>
                Passive biometric authentication using K-Means for anomaly
                detection; live Streamlit dashboard via ADB.
              </p>
            </div>
          </a>
        </div>

        <div className="project-card">
          <a
            href="https://github.com/nevinadacakmak/stoncs"
            target="_blank"
            rel="noopener noreferrer"
            className="project-link"
          >
            <div className="project-content">
              <h3>Stoncs</h3>
              <p>
                ML-powered portfolio optimizer and trend detector using
                sentiment analysis and Snowpark.
              </p>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Projects;
